/**
 * MG Time Tracker Application
 *
 *	TextareaInput.js
 *
 *
 */

// React Imports
import React, { Component } from 'react';

// SASS Imports
require('./InputField.scss');

class TextareaInput extends Component {
    render() {
        return (
            <div className={this.props.colClass}>
                <label>{this.props.title}</label>
                <div className="dropDown">
                    <textarea
                        name={this.props.title}
                        onChange={({ target }) => this.props.onChange(target.value)}
                        placeholder={this.props.placeholder}
                        rows='3'
                        type={this.props.type}
                        value={this.props.value}
                    />
                </div>
            </div>
        );
    }
}

export default TextareaInput;



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/TextareaField.jsx